import { brandsAdapterSelectors } from '../redux/slices/brands';
import { modelsAdapterSelectors } from '../redux/slices/models';
import { createSelector } from 'reselect';
import {
  currentWorkspaceResourceById,
  defaultResourceSelector,
} from './defaultSelectorUtils';

const getCurrentWorkspaceModelsFromStore = (state) =>
  state.currentWorkspace.models;

export const currentWorkspaceModels = createSelector(
  getCurrentWorkspaceModelsFromStore,
  (state) => (id) => modelsAdapterSelectors.selectById(state, id),
  (id) => currentWorkspaceResourceById(id, brandsAdapterSelectors),
  (modelsIds, getModelsById, getBrandById) =>
    modelsIds.map((modelId) =>
      defaultResourceSelector({
        main: {
          resourceId: modelId,
          getResourceById: getModelsById,
        },
        relations: [
          {
            key: 'brand',
            getResourceById: getBrandById,
          },
        ],
      })
    )
);
